import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.footer`
  width: 100%;
  padding: 30px 20px;

  font-size: 14px;
  border-top: 1px solid #eee;
`;

export default () => (
  <Wrapper>
    <p>© 2021 Norway Wood Design. All rights reserved.</p>
  </Wrapper>
);
